import { isTranslated } from '@/settings/localization-settings/guide-localization.utils';
import { sendObjectMetadata } from '@/utils/pendo-object-metadata';
import { isIdeaPollGuide, isNpsGuide, isSurveyGuide } from '@/stores/helpers/guides.helper';

export function sendGuideObjectMetadata (guide) {
    if (!guide?.id) return;

    const translatedLanguageCount = Object.values(guide.translationStates || {}).filter((translation) =>
        isTranslated(translation?.state),
    ).length;

    sendObjectMetadata(guide.id, 'guideId', {
        name: guide.name,
        state: guide.state,
        editorType: guide.editorType,
        launchMethod: guide.launchMethod,
        launchMethods: guide.launchMethod?.split('-').filter(Boolean) || [],
        numSteps: guide.steps?.length || 0,
        isDNT: guide.isDNT,
        hasGoal: Boolean(guide.conversion?.itemId),
        isNps: isNpsGuide(guide),
        isSurvey: isSurveyGuide(guide),
        isIdeaPoll: isIdeaPollGuide(guide),
        hasPoll: Boolean(guide.steps?.some((step) => step.pollIds?.length)),
        isAnnouncement: Boolean(guide.attributes?.isAnnouncement),
        isPartOfExperiment: Boolean(guide.experiment),
        translatedLanguageCount,
        wasCreatedByConversationalAi: Boolean(guide.attributes?.createdByConversationalAi),
    });
}
